import { render, staticRenderFns } from "./ModalAtivarEmpresa.vue?vue&type=template&id=caf939de"
import script from "./ModalAtivarEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalAtivarEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports